import {
  InlineLinkClickHandler,
  InlineLinkProps,
} from './InlineLinkClickHandler';
import {MarkdownText} from './MarkdownText';

export const LinkableMarkdownText = ({
  body,
  isSearchAI,
  onLinkClick,
}: {
  body: string;
  isSearchAI?: boolean;
  onLinkClick: (props: InlineLinkProps) => boolean | void;
}) => {
  return (
    <InlineLinkClickHandler onClick={onLinkClick}>
      <MarkdownText body={body} isSearchAI={isSearchAI} />
    </InlineLinkClickHandler>
  );
};
